export const NextIcon = ({ fill = "#111827", className = "" }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M3 9.25C2.58579 9.25 2.25 9.58579 2.25 10C2.25 10.4142 2.58579 10.75 3 10.75V10V9.25ZM17.5303 10.5303C17.8232 10.2374 17.8232 9.76256 17.5303 9.46967L12.7574 4.6967C12.4645 4.40381 11.9896 4.40381 11.6967 4.6967C11.4038 4.98959 11.4038 5.46447 11.6967 5.75736L15.9393 10L11.6967 14.2426C11.4038 14.5355 11.4038 15.0104 11.6967 15.3033C11.9896 15.5962 12.4645 15.5962 12.7574 15.3033L17.5303 10.5303ZM3 10V10.75L17 10.75V10V9.25L3 9.25V10Z"
      fill={fill}
    />
  </svg>
);
